import instance from "../../utils/axios";

// ✅ Save Give Setting
export const saveGiveSetting = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val ?? ""));
  const response = await instance.post("/churches/givesetting/save", formData);
  return response.data; // { type, data, message, error }
};

// ✅ Update Give Setting
export const updateGiveSetting = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val ?? ""));
  const response = await instance.post("/churches/givesetting/update", formData);
  return response.data;
};

// ✅ Delete Give Setting
export const deleteGiveSetting = async ({ _id, giveObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("giveObjId", giveObjId);
  const response = await instance.post("/churches/givesetting/delete", formData);
  return response.data;
};
